// extracted by mini-css-extract-plugin
export default {"content":"content_content__b5YbT","pageWrapper":"content_pageWrapper__2o2Vg"};